<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{'common.dialog.streetDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content scrollable">
  <form [formGroup]="streetForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">
    <div class="df gap20">
      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 200px; min-width: 200px; max-width: 200px">
        <mat-label>{{'common.dialog.streetDialog.labels.type' | translate}}</mat-label>
        <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="type">
          <mat-option [value]="'STREET'">{{'common.streetTypes.STREET' | translate}}</mat-option>
          <mat-option [value]="'LANE'">{{'common.streetTypes.LANE' | translate}}</mat-option>
          <mat-option [value]="'SQUARE'">{{'common.streetTypes.SQUARE' | translate}}</mat-option>
          <mat-option [value]="'BOULEVARD'">{{'common.streetTypes.BOULEVARD' | translate}}</mat-option>
          <mat-option [value]="'DRIVEWAY'">{{'common.streetTypes.DRIVEWAY' | translate}}</mat-option>
          <mat-option [value]="'DESCENT'">{{'common.streetTypes.DESCENT' | translate}}</mat-option>
          <mat-option [value]="'AVENUE'">{{'common.streetTypes.AVENUE' | translate}}</mat-option>
          <mat-option [value]="'HIGHWAY'">{{'common.streetTypes.HIGHWAY' | translate}}</mat-option>
          <mat-option [value]="'QUAY'">{{'common.streetTypes.QUAY' | translate}}</mat-option>
          <mat-option [value]="'DISTRICT'">{{'common.streetTypes.DISTRICT' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
        <mat-label>{{'common.dialog.streetDialog.labels.name' | translate}}</mat-label>
        <input type="text" matInput formControlName="name">
      </mat-form-field>
    </div>
  </form>
</div>
<div class="buttons-row df jc-e ai-c">
  <button class="default-button apply-button" [disabled]="streetForm.invalid" (click)="submitForm()">
    {{'common.save' | translate}}
  </button>
</div>
